<div class="container-fluid" (keydown)="onKeydown($event)">
  <div class="row">
    <div class="col-md-4 "></div>
    <div class="col-sm-12 col-md-4">
      <div class="container-login" style="width: 100%; margin-top: 50px; text-align: center">
        <div class="imagen-login-container">
          <img class="imagen-login" src="../../../assets/img/captarmedia-login.png">
        </div>
        <div class="form-login">
          <ngb-alert [type]="alertType" *ngIf="successMessage" (close)="successMessage = null"><h5>{{ successMessage }}</h5></ngb-alert><hr/>
          <div class="step-indicator">
            <span class="step-dot" [class.active]="step >= 1">1</span>
            <span class="step-line"></span>
            <span class="step-dot" [class.active]="step >= 2">2</span>
            <span class="step-line"></span>
            <span class="step-dot" [class.active]="step >= 3">3</span>
          </div>
          <div class="step-label">Paso {{step}} de 3</div>

          <!-- Paso 1 — Bienvenida -->
          <div *ngIf="step === 1" class="step-content">
            <h4>Recuperación para administradores</h4>
            <p class="step-description">Usá tu código estático de 6 dígitos para recuperar tu cuenta.</p>
            <p class="step-description small">Si sos administrador y tenés tu código de recuperación, podés restablecer tu contraseña sin necesidad de recibir un email.</p>
            <div class="row container-button">
              <button type="button" class="button-login" (click)="goToStep(2)">Comenzar</button>
            </div>
            <a class="link-login" (click)="irALogin()">Volver al inicio de sesión</a>
          </div>

          <!-- Paso 2 — Código -->
          <div *ngIf="step === 2" class="step-content">
            <h5>Ingresá tu código</h5>
            <p class="step-description small">Ingresá tu email y el código de 6 dígitos que te fue asignado como administrador.</p>
            <form [formGroup]="form" (ngSubmit)="verifyCode()">
              <input formControlName="email" type="email" class="input-login" placeholder="Ingrese su email">
              <div *ngIf="form.get('email').touched && form.get('email').invalid" class="text-danger small">
                <span *ngIf="form.get('email').errors?.required">El email es requerido</span>
                <span *ngIf="form.get('email').errors?.email">Ingrese un email válido</span>
              </div>
              <input formControlName="code" type="text" maxlength="6" class="input-login" placeholder="Código de 6 dígitos">
              <div *ngIf="form.get('code').touched && form.get('code').invalid" class="text-danger small">
                <span *ngIf="form.get('code').errors?.required">El código es requerido</span>
                <span *ngIf="form.get('code').errors?.pattern">El código debe ser de 6 dígitos</span>
              </div>
              <div class="row container-button">
                <button type="submit" class="button-login" [disabled]="pending">Verificar código</button>
              </div>
            </form>
            <a class="link-login" (click)="goToStep(1)">Volver</a>
          </div>

          <!-- Paso 3 — Correo y nueva contraseña -->
          <div *ngIf="step === 3" class="step-content">
            <h5>Restablecer contraseña</h5>
            <p class="step-description small" *ngIf="storedEmail">Recuperando cuenta para: <strong>{{storedEmail}}</strong></p>
            <form [formGroup]="form" (ngSubmit)="changePass()">
              <input formControlName="newPass" type="password" class="input-login" placeholder="Ingrese la nueva contraseña">
              <div *ngIf="form.get('newPass').touched && form.get('newPass').invalid" class="text-danger small">
                <span *ngIf="form.get('newPass').errors?.required">La nueva contraseña es requerida</span>
                <span *ngIf="form.get('newPass').errors?.minlength">La contraseña debe tener al menos 6 caracteres</span>
              </div>
              <input formControlName="confirmPass" type="password" class="input-login" placeholder="Confirme la nueva contraseña">
              <div *ngIf="form.get('confirmPass').touched && form.get('confirmPass').invalid" class="text-danger small">
                <span *ngIf="form.get('confirmPass').errors?.required">Debe confirmar la contraseña</span>
              </div>
              <div class="row container-button">
                <button type="submit" class="button-login" [disabled]="pending">Cambiar contraseña</button>
              </div>
            </form>
            <a class="link-login" (click)="goToStep(2)">Volver</a>
          </div>

        </div>
      </div>
    </div>
    <div class="col-md-4"></div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/admin/admin-code-recovery/admin-code-recovery.component.html